<script setup lang="ts">
import { storeToRefs } from 'pinia';

import { useLayoutStore } from '@/store/useLayoutStore';
import { useMobileDetection } from '@/composables/useMobileDetection';
import { Icon } from '@/storybook/icon';

const layoutStore = useLayoutStore();

const toggleSidebar = () => {
  if (!layoutStore.theaterSidebarCollapsed) {
    layoutStore.toggleExtendedSidebar();
  }
};

const { isSidebarExpanded, theaterSidebarCollapsed } = storeToRefs(layoutStore);
const { isMobile } = useMobileDetection();

defineProps({
  customLogo: Boolean,
});
</script>
<template>
  <button
    :disabled="theaterSidebarCollapsed"
    :aria-label="theaterSidebarCollapsed ? 'Sidebar is collapsed in theater mode' : 'Toggle sidebar'"
    @click="toggleSidebar()"
    data-testid="sidebar-toggle"
    class="absolute p-1 rounded-10 sidebar-switcher h-9 text-slate-300 dark:text-zinc-700 hover:text-slate-500 dark:hover:text-zinc-500 focus:ring focus:ring-blue-500/50 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50"
    :class="[
      isSidebarExpanded ? 'right-6' : '-right-6 border border-slate-200 dark:border-zinc-800 bg-white dark:bg-zinc-900',
      isMobile ? 'hidden' : '',
      customLogo ? 'top-16' : 'top-3',
    ]"
  >
    <Icon v-if="isSidebarExpanded" name="general.menuShrink" size="base" />
    <Icon v-else name="general.menuExpand" size="base" />
  </button>
  <button @click="toggleSidebar()" data-testid="sidebar-toggle-close" class="absolute top-4 right-4 sm:hidden dark:text-zinc-300">
    <Icon name="general.crossLight" size="base" />
    <span class="sr-only">Close</span>
  </button>
</template>
